import { render, staticRenderFns } from "./videoplayer.vue?vue&type=template&id=4f4ac130&scoped=true&"
import script from "./videoplayer.vue?vue&type=script&lang=js&"
export * from "./videoplayer.vue?vue&type=script&lang=js&"
import style0 from "./videoplayer.vue?vue&type=style&index=0&id=4f4ac130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ac130",
  null
  
)

component.options.__file = "videoplayer.vue"
export default component.exports